<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI ĐƠN HÀNG</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT ĐƠN HÀNG</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT ĐƠN HÀNG</h3>
      </div>

      <div class="card-body">
        <el-form ref="orderFormRef" :model="mData.dataForm" label-width="120px" label-position="left">
          <el-row class="margin-bottom-15 first-block">
            <el-col :md="12" class="text-left">
              <p class="title-order-code">
                Mã đơn hàng:
                <span class="margin-left-15">{{
                  mData.dataForm.ma_don_hang
                }}</span>
              </p>
            </el-col>
            <el-col :md="12">
              <p class="trang-thai_don-hang">
                <span class="title-form-status">Trạng thái:</span>
                <el-tag size="large" title="Trạng thái đơn hàng" :class="{
                  'margin-left-10': true,
                  'wait-for-pay':
                    mData.dataForm.trang_thai == 'cho_thanh_toan',
                  paid: mData.dataForm.trang_thai == 'da_thanh_toan',
                  cancel: mData.dataForm.trang_thai == 'huy',
                  'in-process': mData.dataForm.trang_thai == 'dang_xu_ly',
                  'to-return': mData.dataForm.trang_thai == 'hoan_tra',
                  complete: mData.dataForm.trang_thai == 'hoan_thanh',
                }">
                  {{
                    mData.dataForm.trang_thai == "cho_thanh_toan"
                    ? "Chờ thanh toán"
                    : mData.dataForm.trang_thai == "da_thanh_toan"
                      ? "Đã thanh toán"
                      : mData.dataForm.trang_thai == "huy"
                        ? "Hủy"
                        : mData.dataForm.trang_thai == "dang_xu_ly"
                          ? "Đang xử lý"
                          : mData.dataForm.trang_thai == "hoan_tra"
                            ? "Hoàn trả"
                            : mData.dataForm.trang_thai == "hoan_thanh"
                              ? "Hoàn thành"
                              : ""
                  }}
                </el-tag>
                <span title="Trạng thái thanh toán" :class="{
                  paid:
                    mData.dataForm.trang_thai_thanh_toan == 'da_thanh_toan',
                }">
                  <i class="fa-solid fa-coins"></i>
                </span>
              </p>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-table :data="productLists" border style="width: 100%" header-cell-class-name="vt-header-table">
                <el-table-column label="Danh mục đơn hàng" min-width="150">
                  <template #default="scope">
                    <p>{{ scope.row.ten_san_pham }}</p>
                    <div v-for="item in scope.row.arrMotas" :key="item">
                      <p class="margin-left-30">{{ item }}</p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="don_gia" label="Đơn giá" width="150" align="right">
                  <template #default="scope">{{ formatCurrency(scope.row.don_gia) }}</template>
                </el-table-column>
                <el-table-column prop="so_luong" label="Số lượng" width="150" align="center" />
                <el-table-column prop="tong_tien" label="Thành tiền" width="150" align="right">
                  <template #default="scope">{{ formatCurrency(scope.row.tong_tien) }}</template>
                </el-table-column>
              </el-table>
              <div class="text-right margin-top-20">
                <p class="money-check">
                  <span class="bold">TỔNG TIỀN:</span>
                  <span class="bold margin-left-30">{{
                    formatCurrency(mData.dataForm.tong_tien)
                  }}</span>
                </p>
                <p class="money-check margin-top-5">
                  <span class="bold">GIẢM GIÁ:</span>
                  <span class="bold margin-left-30">{{
                    formatCurrency(mData.dataForm.giam_gia)
                  }}</span>
                </p>
                <p class="money-check margin-top-5">
                  <span class="bold">THÀNH TIỀN:</span>
                  <span class="bold margin-left-30">{{
                    formatCurrency(mData.dataForm.thanh_tien)
                  }}</span>
                </p>
              </div>
              <div class="text-left margin-top-15">
                <span>Số tiền bằng chữ:</span>
                <span class="bold margin-left-30">{{
                  capitalizeFirstLetter(
                    toVietnamese(mData.dataForm.thanh_tien ? mData.dataForm.thanh_tien : 0)
                  )
                }}</span>
              </div>
              <div class="text-center margin-top-15">
                <el-button class="icon-button" @click="goBack()">
                  <span>Quay lại</span>
                </el-button>
                <el-button 
                  v-if="showButtonConfirm()" 
                  class="icon-button" 
                  type="success" 
                  plain 
                  @click="confirmOrder()"
                >
                  <span>Xác nhận thanh toán</span>
                </el-button>
                <el-button 
                  v-if="showButtonCancel()"
                  class="icon-button" 
                  type="danger" 
                  plain 
                  @click="cancelOrder()"
                >
                  <span>Hủy đơn hàng</span>
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormDonHang";
import { Circle4 } from "vue-loading-spinner";
export default {
  components: {
    Circle4,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      loading: false,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        loaiDonHang: MethodService.copyObject(DataForm.loaiDonHang),
        agtDaiLyInformation: undefined
      },
      orderStatusLists: [
        {
          value: "cho_thanh_toan",
          label: "Chờ thanh toán",
        },
        {
          value: "da_thanh_toan",
          label: "Chờ xác nhận",
        },
        {
          value: "huy",
          label: "Hủy",
        },
      ],
      productLists: [],
      ten_goiDV_array: [],
      khuyen_mai: {
        ma_giam_gia: undefined, // optional - Mã giảm giá
        noi_dung: undefined, // optional - Nội dung giảm giá
      },
    };
  },
  methods: {
    showButtonConfirm() {
      return (
        this.mData.agtDaiLyInformation && this.mData.agtDaiLyInformation.loai_dong_tien === 've_viettoc' && 
        this.mData.dataForm.trang_thai === 'cho_thanh_toan'
      )
    },
    showButtonCancel() {
      if (this.mData.dataForm.trang_thai == 'huy' || this.mData.dataForm.trang_thai == 'hoan_tra' || this.mData.dataForm.loai_don_hang == 'khoi_tao') return false
      if (
        ((this.mData.dataForm.loai_don_hang == 'khoi_tao' ||
        this.mData.dataForm.loai_don_hang == 'nang_cap' ||
        this.mData.dataForm.loai_don_hang == 'gia_han') && 
        this.mData.dataForm.trang_thai == 'cho_thanh_toan') ||
        (this.mData.dataForm.loai_don_hang == 'in' && this.mData.dataForm.trang_thai != 'hoan_thanh')
      ) {
        return true
      }

      return false
    },
    // lấy toàn bộ tên gói dịch vụ
    async fn_getAllNameGoiDV() {
      try {
        const response = await mushroom.goi_dich_vu.listAsync({
          limit: 100,
        });
        response.result.forEach((item) => {
          this.ten_goiDV_array.push({
            value: item.id,
            label: item.ten,
          });
        });
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    fn_changeGoiDichVu(event) {
      this.goi_dich_vu_id = event;
    },
    async fn_initForm() {
      try {
        const response = await mushroom.ord_don_hang.findByIdAsync({
          id: this.$router.currentRoute.params.id,
        });
        this.mData.dataForm = response.result
        response.result.danh_sach_san_pham.forEach((sp) => {
          sp.arrMotas = sp.mo_ta ? sp.mo_ta.split('\n') : []
        })
        this.productLists = response.result.danh_sach_san_pham
        if (response.result.dai_ly_id) {
          this.getAgtDaiLyInformation(response.result.dai_ly_id)
        } else {
          this.loading = false;
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    async getAgtDaiLyInformation(daiLyId) {
      try {
        const response = await mushroom.agt_dai_ly.findByIdAsync({
          id: daiLyId,
          fields: "id,loai_dong_tien"
        })
        this.mData.agtDaiLyInformation = response.result
        console.log("agtDaiLyInformation:", this.mData.agtDaiLyInformation)
        this.loading = false;
      } catch (e) {
        console.error("Có lỗi getAgtDaiLyInformation: %o", e);
      }
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },

    fn_cancel() {
      this.fn_resetForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    handleChange(value) {
      console.log(value);
    },
    formatCurrency(value) {
      if (value === undefined) return
      return MethodService.formatCurrencyVND(value)
    },
    toVietnamese(value) {
      if (value === undefined) return
      return MethodService.toVietnamese(value)
    },
    capitalizeFirstLetter(value) {
      if (value === undefined) return
      return MethodService.capitalizeFirstLetter(value)
    },
    goBack() {
      this.$router.go(-1)
    },
    confirmOrder() {
      this.$confirm(`Vui lòng chỉ bấm xác nhận khi Việt tộc đã nhận tiền đơn hàng này của khách!`, '', {
        confirmButtonText: `Xác nhận`,
        cancelButtonText: `Hủy`,
        type: 'info'
      }).then(async () => {
        const ord_don_hang_object = {
          id: this.mData.dataForm.id,
          trang_thai_thanh_toan: 'da_thanh_toan'
        }
        try {
          const response = await mushroom.ord_don_hang.partialUpdateAsync(ord_don_hang_object)
          if (response.result === this.mData.dataForm.id) {
            window.toastr.success("Xác nhận thanh toán đơn hàng thành công")
            this.fn_initForm()
          } else {
            window.toastr.success("Xác nhận thanh toán đơn hàng thành công")
          }
        } catch (error) {
          window.toastr.error("Xác nhận thanh toán đơn hàng thất bại")
        }
      })
    },
    cancelOrder() {
      this.$confirm(`Bạn có chắc chắn muốn hủy đơn hàng này không!`, '', {
        confirmButtonText: `Xác nhận`,
        cancelButtonText: `Hủy`,
        type: 'info'
      }).then(async () => {
        const ord_don_hang_object = {
          id: this.mData.dataForm.id,
          trang_thai: 'huy'
        }
        try {
          const response = await mushroom.ord_don_hang.partialUpdateAsync(ord_don_hang_object)
          if (response.result === this.mData.dataForm.id) {
            window.toastr.success("Hủy đơn hàng thành công")
            this.fn_initForm()
          } else {
            window.toastr.success("Hủy đơn hàng thành công")
          }
        } catch (error) {
          window.toastr.error("Hủy đơn hàng thất bại")
        }
      })
    },
  },


  async created() {
    await this.fn_getAllNameGoiDV();
    // kiểm tra loại viewMode
    if (this.$router.currentRoute.name == "ChiTietDonHang") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatDonHang") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>

<style lang="scss" scoped>
.first-block {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
}

.el-tag {
  min-height: 32px;

  // width: 130px;
  &__content {
    font-size: 14px;
    font-weight: 400 !important;
    text-align: center;
  }

  &.wait-for-pay {
    background-color: #d9e5ff;
    color: #000000;
  }

  &.paid {
    background-color: #c6c7f8;
    color: #000000;
  }

  &.cancel {
    background-color: #ff4747;
    color: #ffffff;
  }

  &.in-process {
    background-color: #ffe999;
    color: #000000;
  }

  &.to-return {
    background-color: #e8e8e8;
    color: #000000;
  }

  &.complete {
    background-color: #7ddd96;
    color: #ffffff;
  }
}

.trang-thai_don-hang {
  .title-form-status {
    font-size: 16px;
    font-weight: bold;
  }

  .fa-coins {
    font-size: 22px;
    color: #bdbdbd;
    margin-left: 10px;
  }

  .paid {
    .fa-coins {
      color: #fec800;
    }
  }
}

::v-deep .el-table tbody tr .cell {
  white-space: pre-wrap;
}

.title-order-code {
  font-size: 20px;
  min-height: 32px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.money-check {
  display: flex;
  justify-content: flex-end;

  span:nth-child(2) {
    flex-basis: 110px;
  }
}
</style>
